type EditEventError = {
  emptyName: boolean;
  duplicateName: boolean;
  invalidDateRange: boolean;
  startDateOutOfBound: boolean;
  notFound: boolean;
  listNotFound: boolean;
};

const editEventError: EditEventError = {
  emptyName: false,
  duplicateName: false,
  invalidDateRange: false,
  startDateOutOfBound: false,
  notFound: false,
  listNotFound: false,
};

export type { EditEventError };

export { editEventError };
